import axios from "axios";
import { inject, injectable } from "inversify";
import { API_ENDPOINTS } from "@infrastructure/InfrastructureConstants";
import { runtimeConfig } from "@utils/runtimeConfig/runtimeConfig";
import type { IAuthenticatedRequestHandlerService } from "@application/contracts/services";
import { TYPES } from "@utils/inversifyJS/types";

@injectable()
export class LicenseRepository {
   @inject(TYPES.IAuthenticatedRequestHandlerService)
  private _requestHandlerService!: IAuthenticatedRequestHandlerService;
  
  async saveLicense(licenseKey: string): Promise<void> {
    return this._requestHandlerService.handleRequestAsync<void>(() => axios.post<void>(runtimeConfig.API_BASE_URL + API_ENDPOINTS.license, { licenseKey }));
  }

}
